const EMPTY_ANALYTICS = {
  starts: 0,
  completions: 0,
  uniquePlayers: 0,
  errors: 0,
  trainerAnswers: 0,
  trainerCorrect: 0,
};

export function resolveAnalyticsView(game) {
  const analytics = {
    ...EMPTY_ANALYTICS,
    ...(game?.analytics ?? {}),
  };
  const sessions = game?.playSessions ?? [];

  return {
    analytics,
    sessions,
    isDemo: false,
    demoLabel: null,
  };
}

export function formatAnalyticsCount(value) {
  return new Intl.NumberFormat("ru-RU").format(value ?? 0);
}

export function getProjectAnalyticsPreview(game) {
  const { analytics } = resolveAnalyticsView(game);
  const starts = analytics.starts ?? 0;
  const completions = analytics.completions ?? 0;
  const uniquePlayers = analytics.uniquePlayers ?? 0;
  const conversion = starts > 0 ? Math.round((completions / starts) * 100) : 0;

  return {
    starts,
    completions,
    uniquePlayers,
    conversion,
    isDemo: false,
    hasData: starts > 0 || completions > 0 || uniquePlayers > 0,
  };
}
